import { render } from "./logo.vue?vue&type=template&id=6b91fade"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b91fade"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b91fade', __exports__)) {
    api.reload('6b91fade', __exports__)
  }
  
  module.hot.accept("./logo.vue?vue&type=template&id=6b91fade", () => {
    api.rerender('6b91fade', render)
  })

}


export default __exports__